// all styles here
import "./src/assets/css/bootstrap.min.css"
import "./src/assets/css/animate.min.css"
import "./src/assets/css/flaticon.css"
import "./src/assets/css/style.css"
import "./src/assets/css/responsive.css"
import "./src/assets/css/styleScss.scss"

export const onRouteUpdate = ({ location }) => {
// Check if the path includes "getap"
if (location.pathname.includes("gemai-convos")) {
    console.log('Path includes "getap". Loading CSS.');
    // Load the additional CSS file
    const link = document.createElement("link");
    link.href = "/components/GemAI/assets/css/General.css"; // Replace with the actual path to your CSS file
    link.rel = "stylesheet";

    document.head.appendChild(link);
}
};

// Firefox compatibility fixes
export const onClientEntry = () => {
  // Detect Firefox
  const isFirefox = typeof InstallTrigger !== 'undefined';
  
  if (isFirefox) {
    // Add Firefox-specific meta tags for better HTTP/3 compatibility
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Accept-CH';
    meta.content = 'Sec-CH-UA, Sec-CH-UA-Mobile, Sec-CH-UA-Platform';
    document.head.appendChild(meta);
    
    // Force HTTP/2 fallback for Firefox if needed
    if (window.location.protocol === 'https:') {
      console.log('Firefox detected - optimizing for HTTP/2 compatibility');
    }
  }
};